// @flow
import type { Node } from 'react';
import useNow from '../../hooks/useNow';

type Props = $ReadOnly<{
    interval?: number,
    disabled?: boolean,
    children: Node
}>;

function NowFeeder({ interval, disabled, children }: Props) {
    const now = useNow(interval, disabled);
    return children(now);
}

export default NowFeeder;